// extracted by mini-css-extract-plugin
export default {"dataDisclaimer":"data-disclaimer-module-dataDisclaimer--tUOTX"};